import useSelectHelpers from 'Hooks/useSelectHelpers'

import { FormElement, Select } from 'mailup-web-components'

import { workflowCommonDataState } from 'Pages/Workflow/recoil/state/data'

import { step2State } from 'Pages/Workflow/recoil/state/step2'
import { useState } from 'react'
import { useIntl } from 'react-intl'
import { useRecoilValue, useSetRecoilState } from 'recoil'

const InputIdFilter = () => {
  const intl = useIntl()

  const [idFilterIsDirty, setIdFilterIsDirty] = useState(false)

  const { IdFilter } = useRecoilValue(step2State)
  const setWorkflowDetailsState = useSetRecoilState(step2State)

  const { profileFilters, profileFiltersCategories } = useRecoilValue(
    workflowCommonDataState
  )

  const requiredFeedback = intl.formatMessage({
    id: 'Load.MailupCommon.Required'
  })

  const handleFilterChange = (value) => {
    setWorkflowDetailsState((prev) => ({
      ...prev,
      IdFilter: value
    }))
    setIdFilterIsDirty(true)
  }

  const selectFilterProps = useSelectHelpers(
    IdFilter,
    profileFilters,
    true,
    idFilterIsDirty
  )

  return (
    <FormElement
      label={intl.formatMessage({
        id: 'Load.AutomationWorkflow.SelectExistingFilterLabel'
      })}
      required
      feedback={idFilterIsDirty && !IdFilter ? requiredFeedback : undefined}
      variant={idFilterIsDirty && !IdFilter ? 'danger' : undefined}
    >
      <Select
        searchable
        placeholder={intl.formatMessage({
          id: 'Load.AutomationWorkflow.SelectExistingFilterPlaceholder'
        })}
        value={IdFilter}
        options={profileFilters}
        optionGroups={profileFiltersCategories}
        onChange={handleFilterChange}
        {...selectFilterProps}
      />
    </FormElement>
  )
}

export default InputIdFilter
